import { SEVERITY } from '@hapana/shared/web/components/shared/banner-alert/banner-alert.constants'
import successUrl from '_assets/sounds/alert-success.mp3'
import warningUrl from '_assets/sounds/alert-warning.mp3'
import errorUrl from '_assets/sounds/alert-error.mp3'

const canUseAudio = typeof window !== 'undefined' && typeof Audio !== 'undefined'

const audios = canUseAudio
  ? {
      [SEVERITY.SUCCESS]: new Audio(successUrl),
      [SEVERITY.WARNING]: new Audio(warningUrl),
      [SEVERITY.ERROR]: new Audio(errorUrl),
    }
  : {}

if (canUseAudio) {
  Object.values(audios).forEach((a) => {
    a.preload = 'auto'
  })
}

let hasUnlockedAudio = false
let primingPromise = null

const unlockSilently = (audio) => {
  return new Promise((resolve) => {
    try {
      const previousMuted = audio.muted
      const previousVolume = audio.volume
      audio.muted = true
      audio.volume = 0
      const playPromise = audio.play()
      const finish = () => {
        try {
          audio.pause()
          audio.currentTime = 0
        } catch (_) {}
        audio.muted = previousMuted
        audio.volume = previousVolume
        resolve()
      }
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.then(finish).catch(finish)
      } else {
        finish()
      }
    } catch (_) {
      resolve()
    }
  })
}

export const primeCheckInSounds = () => {
  if (!canUseAudio) return Promise.resolve()
  if (hasUnlockedAudio) return Promise.resolve()
  if (primingPromise) return primingPromise
  primingPromise = Promise.all(Object.values(audios).map(unlockSilently))
    .then(() => {
      hasUnlockedAudio = true
    })
    .finally(() => {
      primingPromise = null
    })
  return primingPromise
}

export const playCheckInSoundForSeverity = (severity) => {
  if (!canUseAudio) return
  const audio = audios[severity] || audios[SEVERITY.ERROR]
  if (!audio) return
  try {
    Object.values(audios).forEach((a) => {
      if (a !== audio) {
        try {
          a.pause()
          a.currentTime = 0
        } catch (_) {}
      }
    })
    audio.currentTime = 0
    audio.muted = false
    audio.volume = 1
    audio.play().catch(() => {})
  } catch (_) {}
}
